import { useEffect, useState } from "react";
import { i18n } from "../../translate/i18n";
import { Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from "@mui/material";
import { Button } from "@material-ui/core";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import SingleSelect from "../InputStyled/singleSelect";
import { useHistory } from "react-router-dom";

const TicketsQueueSelect = ({
  connectionId,
  ticketId,
  onClose,
  open,
}) => {

  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [queues, setQueues] = useState([]);
  const [selectedQueue, setSelectedQueue] = useState([]);

  useEffect(() => {
    if (open != true) return;

    let isMounted = true;
    const abortController = new AbortController();
    setLoading(true);

    (async () => {
      try {

        // resgatar filas da conexão e usuário
        const { data: queues } = await api.get(`/queue/userConnectionQueues/${connectionId}`, {
					signal: abortController.signal,
				});

				if (!isMounted) {
          setLoading(false);
          return;
        }
        setTimeout(() => {
          setQueues(queues);
          setLoading(false);
        }, 500);
      } catch (err) {
        setLoading(false);
        if (!isMounted || err.name == 'AbortError') return;
				console.error({err});
				toastError(err);
      }
    })();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, [open])

  const handleClose = (event, reason) => {
    if (reason == 'backdropClick') {
			event.preventDefault();
			return;
		}

    setQueues([]);
    setSelectedQueue([]);
    onClose();
  };

  const handleSave = () => {
    (async () => {
      try {
        // resgatar filas da conexão e usuário
        setLoading(true);
        const { data } = await api.put(`/tickets/${ticketId}`, {
          status: "open",
          queueId: selectedQueue,
          ticketId
        });
        setLoading(false);
        handleClose();
        setTimeout(() => {
          history.push(`/tickets/${data.uuid}`);
          document.querySelector('#ticketTabOptions button').click();
        }, 500);
      } catch (err) {
        setLoading(false);
				console.error({err});
				toastError(err);
      }
    })();
  }

  return (
    <Dialog
      open={open == true ? true : false}
      onClose={(event, reason) => handleClose(event, reason)}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      disableEscapeKeyDown={true}
      disableAutoFocus 
      disableEnforceFocus
    >
      <DialogTitle id="form-dialog-title">Fila para o Atendimento</DialogTitle>
      <DialogContent dividers>
        <SingleSelect
          key={`ticketQueue`}
          id={`ticketQueue`}
          title="Selecione uma fila para o atendimento"
          displayText="Selecionar Fila"
          name="ticketQueue"
          options={Array.isArray(queues) ? queues.filter(q => q.name != "FILA_CHATBOT").map(q => { return { key: q.id, value: q.name, disabled: false } }) : []}
          onSelected={(id) => {
            setSelectedQueue(id);
          }}
          selected={selectedQueue}
          closeOnSelect
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          color="secondary"
          disabled={loading}
          variant="outlined"
        >
          {i18n.t("buttons.close")}
        </Button>
        <Button
          type="submit"
          color="primary"
          disabled={loading}
          variant="contained"
          onClick={handleSave}
        >
          {`${i18n.t("buttons.save")}`}
          {loading && (
            <CircularProgress
              size={24}
            />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketsQueueSelect;
